import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import * as _ from 'lodash'

import MessageBoxFunctionalLayout from 'components/shared/MessageBoxFunctionalLayout'
import IntegrationsButtons from '../../integrations/IntegrationsButtons'
import * as integrationType from 'constants/integrationType'
import ShopifyConnect from '../../integrations/ShopifyConnect'
import { HELVETICA, TEAL, LIGHT_GRAY } from '../../styles'


const Content = styled.div`
  width: 100%;
  height: 36em;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const HeaderText = styled.div`
  width: 100%;
  margin-top: 2em;
  margin-bottom: 2em;
  text-align: center;
  ${HELVETICA};
  font-size: 36px;
  font-weight: 300;
  color: #72a4a3;
`
const DataContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 8
`
const Footer = styled.div`
  width: 95%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1
`
const ButtonTransparent = styled.div`
  width: 157px;
  height: 52px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${LIGHT_GRAY};
  ${HELVETICA};
  font-size: 23px;
  font-weight: 500;
  cursor: pointer;
  border: solid 1px #9b9b9b;
`
const ButtonTeal = ButtonTransparent.extend`
  background-color: ${TEAL};
  color: #FFF;
  border: solid 1px ${TEAL};
`
const IntegrationParamsContainer = styled.div`
  width: 60%
`

class EcommerceConnect extends Component {

  constructor (props) {
    super(props)
    this.state = {
    }
  }

  renderIntegrationParams () {
    const { temporaryIntegrationData, appId, selectedIntegration } = this.props
    switch (selectedIntegration) {
      case integrationType.SHOPIFY:
        return (
          <ShopifyConnect
            appId={appId}
            shopName={_.get(temporaryIntegrationData, [appId, 'shopName'])}
            accessToken={_.get(temporaryIntegrationData, [appId, 'accessToken'])}
            showDivider={false}
          />
        )
      default:
        return null
    }
  }


  renderContent () {
    const { toPrevStep, templateId, selectedIntegration, onSelectIntegration, handleCreateApp } = this.props
    return (
      <Content>
        <DataContainer>
          <HeaderText>Integrate your ecommerce platform</HeaderText>
          <IntegrationsButtons
            templateId={templateId}
            selectedIntegration={selectedIntegration}
            onSelectIntegration={onSelectIntegration}
          />
          <IntegrationParamsContainer>
            {this.renderIntegrationParams()}
          </IntegrationParamsContainer>
        </DataContainer>
        <Footer>
          <ButtonTransparent onClick={toPrevStep}>Previews</ButtonTransparent>
          <ButtonTeal onClick={handleCreateApp}>Next</ButtonTeal>
        </Footer>
      </Content>
    )
  }

  render () {
    const { handleCancel } = this.props
    return (
      <MessageBoxFunctionalLayout
        theme='blue'
        title='Connect your ecommerce'
        onCancel={handleCancel}
        disableConfirmation
        hideFooter
        width='60em'
      >
        {this.renderContent()}
      </MessageBoxFunctionalLayout>
    )
  }
}

EcommerceConnect.defaultProps = {
  temporaryIntegrationData: {}
}

EcommerceConnect.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  toPrevStep: PropTypes.func.isRequired,
  selectedIntegration: PropTypes.string,
  onSelectIntegration: PropTypes.func.isRequired,
  templateId: PropTypes.string.isRequired,
  temporaryIntegrationData: PropTypes.object,
  appId: PropTypes.string.isRequired,
  handleCreateApp: PropTypes.func.isRequired,
}

export default connect()(EcommerceConnect)



// WEBPACK FOOTER //
// ./src/components/dashboard/instagramWizard/EcommerceConnect.js